import { Fragment } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import { ProductModel } from '@/models';
import { getProductImage } from '@/utils/productUtils';

import Tile from '@/components/common/Tile';
import Divider from '@/components/common/Divider';
import Icon from '@/components/common/iconedLinks/Icon';
import FullScreenContainerV2 from '@/components/layout/modals/FullScreenContainerV2';
import { useProductsPerAvailableType } from '@/components/checkout/shipMode/useProductsPerAvailableType';

import styles from './ProductsPerAvailableTypeModal.module.scss';
import { URLS } from '@/constants/urls';

export const ProductsPerAvailableTypeModal = () => {
  const { t } = useTranslation();
  const presenter = useProductsPerAvailableType();

  return (
    <FullScreenContainerV2
      onClose={() => presenter.hideProductsPerAvailableTypeModal()}
      isOpen={presenter.productPerAvailableTypeModalIsOpened}
      overlay designSystemHeader={presenter.headerProps}
      animationClass={presenter.animation}
      classNames={{ container: styles.container, content: styles.content }}
    >
      <>
        {presenter.shippingId !== 'P' && (
          <>
            {((presenter.shippingId === 'L' && presenter.deliveryFrom) ||
                (presenter.shippingId === 'PA' && presenter.orderBefore !== '1 January 1970')) &&
              (<Tile
                borderless subParagraphPosition="top" padding="none"
                leadingContent={<Icon src={URLS.DELIVERY_CIRCLE} alt="shipping" width={48} height={48} />}
                content={{
                  paragraph: <Trans
                    i18nKey={`checkout:shipMode.delivery.${presenter.shippingId}`}
                    values={{ orderDate: presenter.orderBefore, deliveryDate: presenter.deliveryFrom }}
                    components={{ dateStyle: <span className={styles.date} /> }}
                  />,
                }}
                className={styles.tile}
              />)
            }
            <Divider spacing={16} />
          </>
        )}
        {presenter.products.map((product: ProductModel & { quantity: string | number }, index: number) => {
          const productPackaging =
            product.item.shortdesc ? product.item.shortdesc.charAt(0).toUpperCase() + product.item.shortdesc.slice(1) : '';

          return (
            <Fragment key={index}>
              <div className={styles.product}>
                <div className={styles['img-container']}>
                  <img src={getProductImage(product.image, false, 'thumb')} alt={product.productName} width={100} height={92} />
                </div>
                <section className={styles['product-infos']}>
                  <p className={styles['product-name']}>{product.productName}</p>
                  <p className={styles['product-packaging']}>{productPackaging}</p>
                  <p className={styles['product-packaging']}>{t('product.quantity')} {product.quantity}</p>
                </section>
              </div>
              <Divider spacing={16}/>
            </Fragment>
          );
        })}
      </>
    </FullScreenContainerV2>
  );
};
